exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "a.user-chip {\n  flex-direction: row;\n  display: flex;\n  align-items: center;\n  padding: 3px 0;\n  text-decoration: none;\n  color: white;\n  font-size: 14px;\n  font-weight: 300; }\n  a.user-chip img {\n    width: 20px;\n    height: 20px;\n    border-radius: 10px;\n    margin-right: 6px; }\n  a.user-chip:focus, a.user-chip:visited {\n    text-decoration: none;\n    color: white; }\n  a.user-chip:hover {\n    text-decoration: underline; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/UserChip.scss
// module id = 695
// module chunks = 0